"use strict"

import _ from "lodash"
import angular from "angular"

import { kStandardLabels } from "../counter-label"

angular.module("uCountitUiApp").factory("GenderAge", function ($rootScope, Locale) {
  const getStandardLabelsSeedCounterList = function () {
    return kStandardLabels.map((label) => ({
      name: Locale.string(label.i18nKey),
      value: label.seedCounter,
      group: "",
    }))
  }

  const getSeedCounterList = function (labels) {
    const labelList = []

    _.forEach(labels, function (label) {
      if (label._id) {
        return labelList.push({
          name: label.name,
          value: label._id,
        })
      }
    })

    return [{ name: Locale.string("None"), value: "None", group: " " }]
      .concat(getStandardLabelsSeedCounterList())
      .concat(labelList)
  }

  return {
    getSeedCounterList,
  }
})
